import { map } from 'rxjs/operators';
import { Instruction } from '../../shared/models/instruction.model';
import { MappedCollectionResponse } from '../models/mapped-collection-response.model';
import { ResponseNode } from '../models/response-node.model';

export const createInstructionObjects = map((response: MappedCollectionResponse): Array<Instruction> => (
  response.data.map((element: ResponseNode): Instruction => new Instruction().deserialize(element, response.includedMap))
));
